import { useState, useEffect, useMemo } from 'react';
import { DateTime } from 'luxon';
import { useDispatch, useSelector } from 'react-redux';
import { useDebounce } from 'react-use';

import { useGetConfigurationFormatToDocMutation } from '@greenkub-fronts/data-access';
import { paginateItems } from '@greenkub-fronts/shared/utils';
import {
  Address,
  AppDispatch,
  FixMe,
  Project,
  RootState,
} from '@greenkub-fronts/shared/interface';
import { addErrorMessage } from '@greenkub-fronts/domain/snackbar';
import {
  getCurrentProject,
  openModalSignature,
  updateProjectUseCase,
} from '@greenkub-fronts/domain/signature';

import Bdc from '../../../ui/web/template/bdc/bdc';

export interface BdcFeatureProps {
  sign1Ref: FixMe;
  sign2Ref: FixMe;
}

const BdcFeature = (props: BdcFeatureProps) => {
  const { sign1Ref, sign2Ref } = props;

  const dispatch = useDispatch<AppDispatch>();

  const { isSignature, signature, signatures, initSignaturePage } = useSelector(
    (state: RootState) => state.signature
  );

  const [project, setProject] = useState<Project>();

  const selectedProject = useSelector((state: RootState) =>
    getCurrentProject(state)
  );

  const [getConfigurationFormatToDoc] =
    useGetConfigurationFormatToDocMutation();

  useEffect(() => {
    if (selectedProject) setProject(selectedProject);
  }, [selectedProject]);

  /**
   * STATE
   */
  const [address, setAddress] = useState<Address>();
  const [adjustment, setAdjustment] = useState<number>();
  const [comment, setComment] = useState<string>();
  const [itemPages, setItemPages] = useState<[[]]>([[]]);

  /**
   * INIT
   */
  useEffect(() => {
    if (!project) return;
    setAddress(project?.address ?? undefined);
    setComment(project?.notes ?? '');
    setAdjustment(project.adjustment || 0);
  }, [project?.id]);

  /**
   * EDITION
   */
  useDebounce(
    () => {
      if (!isSignature) {
        dispatch(
          updateProjectUseCase({
            displayMsg: true,
            comment: comment || '',
            address: address as FixMe,
            adjustment: adjustment || 0,
          })
        );
      }
    },
    500,
    [comment, adjustment, address]
  );

  /**
   * Valeur calculé
   */
  const localDatetime = useMemo(() => {
    return DateTime.local().toFormat('d/LL/y');
  }, []);

  const isKit = useMemo(() => {
    if (!project || !project.configurations) return false;
    return (
      project?.configurations[0]?.chosenStudioList?.studio?.model?.name.includes(
        'KIT'
      ) || false
    );
  }, [project]);

  /**
   * Récup du projet
   */
  useEffect(() => {
    if (!project) return;
    getConfigurationFormatToDoc({
      configurations: project.configurations,
    }).then((resp: any) => {
      if (resp.error) {
        dispatch(addErrorMessage(resp.error));
      } else {
        setItemPages(paginateItems(resp.data) as FixMe);
      }
    });
  }, [project]);

  /**
   * Handler d'input
   */
  const updateAdjustment = (newAdjustment: number) => {
    setAdjustment(newAdjustment);
  };

  const updateAddress = (addressValue: Address) => {
    setAddress(addressValue);
  };

  const updateComment = (event: FixMe) => {
    setComment(event.target.value);
  };

  return (
    <Bdc
      isKit={isKit}
      project={project as FixMe}
      isSignature={isSignature}
      signature={signature}
      signatures={signatures}
      sign1Ref={sign1Ref}
      sign2Ref={sign2Ref}
      handleOpenModalSignHandler={(index: number) =>
        dispatch(openModalSignature({ currentIndexSignature: index }))
      }
      address={address as FixMe}
      updateAddress={updateAddress}
      totalPrice={project?.totalPrice || 0}
      adjustment={adjustment || 0}
      updateAdjustment={updateAdjustment}
      totalVatAdjusted={
        project?.totalVat && project?.adjustment
          ? project.totalVat - project.adjustment / 5
          : project?.totalVat ?? 0
      }
      totalPriceWithVatAdjusted={
        project?.totalPriceWithVat && project?.adjustment
          ? project?.totalPriceWithVat - (project?.adjustment / 5) * 6
          : project?.totalPriceWithVat ?? 0
      }
      comment={comment || ''}
      setComment={setComment}
      updateComment={updateComment}
      localDatetime={localDatetime}
      itemPages={itemPages}
    />
  );
};

export default BdcFeature;
